import { useState, useEffect, useCallback } from "react";
import useHttpErrorHandler from "src/hooks/useHttpErrorHandler";
import * as Api from "../api";
import { IUserProductContainer } from "../types";

type StateTypes = {
  fetching: boolean;
  data?: IUserProductContainer;
};

const useGet = (id: UserProductId) => {
  const { handleError } = useHttpErrorHandler();
  const [state, setState] = useState<StateTypes>({
    fetching: false
  });

  const fetchProduct = useCallback(
    async (userProductId: UserProductId) => {
      setState(s => ({ ...s, fetching: true }));
      try {
        const resp = await Api.getUserProduct(userProductId);
        setState({ fetching: false, data: resp.value });
      } catch (e) {
        handleError(e);
        setState({ fetching: false, data: undefined });
      }
    },
    [handleError]
  );

  useEffect(() => {
    if (id) {
      fetchProduct(id);
    }
  }, [fetchProduct, id]);

  return { ...state };
};

export default useGet;
